import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart'

import colors from '@/assets/scss/_themes-vars.module.scss'

export type AddHealthDataButtonProps = {
  onClick?: () => void
}

export function AddHealthDataButton(props: AddHealthDataButtonProps) {
  const { onClick } = props
  const { t } = useTranslation()

  return (
    <Button
      data-testid="add-consultation-button"
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        width: '100%',
        position: 'relative',
        border: `1px dashed ${colors.gray300}`,
        borderRadius: '8px',
      }}
    >
      <Box component="div" sx={{ pt: '70%', position: 'relative' }}>
        <Stack
          alignItems="center"
          justifyContent="center"
          spacing={1}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <MonitorHeartIcon htmlColor={colors.indigo700} />
          <Chip color="primary" label={t('common:button.add.label')} size="small" variant="filled" sx={{ cursor: 'pointer' }} />
        </Stack>
      </Box>
    </Button>
  )
}

export default AddHealthDataButton
